export const IMAGE_TYPE_NO_USAGE = 0;
export const IMAGE_TYPE_LANDSCAPE = 1;
export const IMAGE_TYPE_PORTRAIT = 2;
export const IMAGE_TYPE_TEXT_BACKGROUND = 3;
export const IMAGE_TYPE_LOGO = 4;
export const IMAGE_TYPE_PAGE_CONTENT = 5;
export const IMAGE_TYPE_PRODUCT_IMAGE = 6;